import { SliderSettings } from "../../../../Shared/components/CardLayout/SliderSettings";
import { useLogging } from "../../../../Shared/hooks/useLogging/useLogging";
import getWeekdayNumber from "../../../../Shared/utils/isWeekday";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ImageDisplay, MealQuantitySelectionMode, ModuleNames, } from "../../../OrderFlowProvider/OrderFlowTypes";
import { GetDayName } from "../../../utils/orderFlowUtils";
/**
 * Handles increment, decrement of MQM program meals
 * @returns
 */
export const useMealQuantity = (sequenceNumber) => {
    var _a;
    const { store, dispatch } = useOrderFlow();
    const { createKlaviyoEvent } = useLogging();
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((module) => module.ModuleName === ModuleNames.MEAL_QUANTITY &&
        module.Sequence === sequenceNumber &&
        module.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    const toggleTemplate = store.cart.toggleTemplate;
    let selectMode = moduleConfig.MealQuantitySelectionMode;
    let selectModeWeekDay = getWeekdayNumber(selectMode);
    const SameMealQuantitiesEachMealDay = selectMode === MealQuantitySelectionMode.SameMealQuantitiesEachMealDay;
    let addedMeals = true;
    const handleQuantityIncrement = (CustomerEditable, dispatch, addedMeals, sku, template, isEditFlow, CompanyUsesKlaviyo, sameMealQuantitiesEachMealDay) => (meal, day, quantity) => {
        if (CustomerEditable) {
            quantity += 1;
            handleMealQuantityChange(dispatch, addedMeals, sku, template, isEditFlow, CompanyUsesKlaviyo, meal, day, quantity, sameMealQuantitiesEachMealDay);
        }
    };
    const handleQuantityDecrement = (CustomerEditable, dispatch, addedMeals, sku, template, isEditFlow, CompanyUsesKlaviyo, sameMealQuantitiesEachMealDay) => (meal, day, quantity) => {
        if (CustomerEditable) {
            quantity -= 1;
            handleMealQuantityChange(dispatch, addedMeals, sku, template, isEditFlow, CompanyUsesKlaviyo, meal, day, quantity, sameMealQuantitiesEachMealDay);
        }
    };
    const handleMealQuantityChange = (dispatch, addedMeals, sku, template, isEditFlow, CompanyUsesKlaviyo, meal, day, quantity, sameMealQuantitiesEachMealDay) => {
        if (sameMealQuantitiesEachMealDay) {
            if (template.some((tm) => tm.ProgramMealId === meal.ProgramMealId)) {
                template.forEach((templateMeal) => {
                    if (templateMeal.ProgramMealId === meal.ProgramMealId) {
                        addedMeals = quantity >= templateMeal.Quantity;
                        templateMeal.Quantity = quantity;
                    }
                });
            }
            else {
                for (let i = 0; i <= 6; i++) {
                    let newMeal = {
                        ProgramMealId: meal.ProgramMealId,
                        ProgramMealName: meal.MealName,
                        Price: meal.Price,
                        DayOfWeek: i,
                        Quantity: quantity,
                        MealSize: meal.MealSize,
                        MealTypeId: meal.MealTypeId
                    };
                    template.push(newMeal);
                }
            }
        }
        else {
            if (template.some((m) => m.ProgramMealId === meal.ProgramMealId && m.DayOfWeek === day)) {
                template.forEach((m) => {
                    if (m.ProgramMealId === meal.ProgramMealId && m.DayOfWeek === day) {
                        addedMeals = quantity >= m.Quantity;
                        m.Quantity = quantity;
                    }
                });
            }
            else {
                let newMeal = {
                    ProgramMealId: meal.ProgramMealId,
                    ProgramMealName: meal.MealName,
                    Price: meal.Price,
                    DayOfWeek: day,
                    Quantity: quantity,
                    MealSize: meal.MealSize,
                    MealTypeId: meal.MealTypeId
                };
                template.push(newMeal);
            }
        }
        if (!isEditFlow && CompanyUsesKlaviyo) {
            const eventInfo = {
                MealName: meal.MealName,
                Quantity: quantity,
                DayOfWeek: GetDayName(day),
                SKU: sku,
            };
            const eventName = (addedMeals ? "Added" : "Removed") + " Meal";
            createKlaviyoEvent(eventName, eventInfo);
        }
        dispatch({ type: ActionTypes.SET_TEMPLATE, payload: template.filter((tm) => tm.Quantity > 0) });
        dispatch({ type: ActionTypes.SET_RECIPE_FETCH_STATUS, payload: { completed: false, error: false } });
    };
    const handleToggle = (dispatch, toggleTemplate, template, SameMealQuantitiesEachMealDay) => (meal, day) => {
        let mealAndDayMatch = (m) => m.ProgramMealId === meal.ProgramMealId && (m.DayOfWeek === day || SameMealQuantitiesEachMealDay);
        if (template.some(mealAndDayMatch)) {
            template.filter(mealAndDayMatch).forEach((m) => {
                m.Quantity = 0;
            });
        }
        else {
            let toggleTemplateMeal = toggleTemplate ? toggleTemplate.find(mealAndDayMatch) : null;
            let toggleQuantity = (toggleTemplateMeal && toggleTemplateMeal.Quantity) || 1;
            if (SameMealQuantitiesEachMealDay) {
                for (let i = 0; i <= 6; i++) {
                    let newMeal = {
                        ProgramMealId: meal.ProgramMealId,
                        ProgramMealName: meal.MealName,
                        Price: meal.Price,
                        DayOfWeek: i,
                        Quantity: toggleQuantity,
                    };
                    template.push(newMeal);
                }
            }
            else {
                let newMeal = {
                    ProgramMealId: meal.ProgramMealId,
                    ProgramMealName: meal.MealName,
                    Price: meal.Price,
                    DayOfWeek: day,
                    Quantity: toggleQuantity,
                };
                template.push(newMeal);
            }
        }
        dispatch({ type: ActionTypes.SET_TEMPLATE, payload: template.filter((tm) => tm.Quantity > 0) });
        dispatch({ type: ActionTypes.SET_RECIPE_FETCH_STATUS, payload: { completed: false, error: false } });
    };
    const filteredProgramMeals = store.model.Program.ProgramMeals.filter((programMeal) => {
        var _a, _b, _c, _d;
        if ((programMeal.MealSize === ((_b = (_a = store === null || store === void 0 ? void 0 : store.cart) === null || _a === void 0 ? void 0 : _a.mealSize) === null || _b === void 0 ? void 0 : _b.Size) ||
            ((_d = (_c = store === null || store === void 0 ? void 0 : store.cart) === null || _c === void 0 ? void 0 : _c.mealSize) === null || _d === void 0 ? void 0 : _d.Size) === store.model.allMealSizeOption) &&
            !moduleConfig.MealTypesToHide.includes(programMeal.ProgramMealId)) {
            return programMeal;
        }
    });
    const daysToRender = store.model.DeliveryScheduleMealDays
        ? store.model.DeliveryScheduleMealDays.filter((mealDay) => {
            let keepMealDay = true;
            if (selectModeWeekDay !== -1) {
                keepMealDay = mealDay === selectModeWeekDay;
            }
            return keepMealDay;
        })
        : [];
    return {
        handleQuantityIncrement: handleQuantityIncrement(moduleConfig.CustomerEditable, dispatch, addedMeals, store.model.Sku, store.cart.template, store.model.IsEditFlow, store.model.CompanyUsesKlaviyo, SameMealQuantitiesEachMealDay),
        handleQuantityDecrement: handleQuantityDecrement(moduleConfig.CustomerEditable, dispatch, addedMeals, store.model.Sku, store.cart.template, store.model.IsEditFlow, store.model.CompanyUsesKlaviyo, SameMealQuantitiesEachMealDay),
        handleToggle: handleToggle(dispatch, toggleTemplate, store.cart.template, SameMealQuantitiesEachMealDay),
        programMealsToRender: filteredProgramMeals || store.model.Program.ProgramMeals,
        SameMealQuantitiesEachMealDay,
        cartTemplate: store.cart.template,
        daysOfWeek: store.cart.daysOfWeek,
        daysToRender,
        isDisabled: !moduleConfig.CustomerEditable,
        isVisible: moduleConfig.Visible,
        ScreenXS: moduleConfig.ScreenXS,
        ScreenSM: moduleConfig.ScreenSM,
        ScreenMD: moduleConfig.ScreenMD,
        ScreenLG: moduleConfig.ScreenLG,
        GridSpacing: moduleConfig.GridSpacing,
        imageHeight: moduleConfig.ImageHeight,
        ImageDisplay: moduleConfig.ImageDisplayMode,
        ShowMealImages: moduleConfig.ImageDisplayMode === ImageDisplay.NoImage ? false : true,
        ShowMealDescriptions: moduleConfig.ShowMealDescriptions,
        DisplayAdditionalInfoBtn: moduleConfig.DisplayAdditionalInfoBtn,
        AdditionalInfoBtnText: moduleConfig.AdditionalInfoBtnText,
        DescriptionLines: moduleConfig.DescriptionLines,
        ToggleMode: moduleConfig.ToggleMode,
        sliderSettings: SliderSettings(moduleConfig.ScreenLG, moduleConfig.ScreenMD, moduleConfig.ScreenSM, moduleConfig.ScreenXS),
        imageBaseUrl: store.model.ProgramMealImageBaseUrl,
        defaultMealTypeImage: moduleConfig.DefaultMealTypeImage,
        CenterCards: moduleConfig.CenterCards,
    };
};
